module.exports = {"510124001":"郫筒街道","510124019":"合作街道","510124020":"西园街道","510124101":"团结镇","510124102":"犀浦镇","510124103":"花园镇","510124104":"唐昌镇","510124105":"安德镇","510124106":"三道堰镇","510124107":"安靖镇","510124108":"红光镇","510124110":"新民场镇","510124112":"德源镇","510124115":"友爱镇","510124117":"古城镇","510124118":"唐元镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510124.json
// module id = 2086
// module chunks = 0